import { } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { EloquaObjectDataset } from 'app/model/dataset/eloqua.dataset';
import { TabularCopySource } from './tabular-type.copysource';

@Metamodel.model({
    name: 'EloquaSource',
    display: [],
    tags: { datasetModel: Metamodel.modelFor(EloquaObjectDataset) }
})
export class EloquaCopySource extends TabularCopySource {
}
